export default __webpack_public_path__ + "static/media/exposure.7d83050d.png";